module.exports = __webpack_public_path__ + "img/RecycleBin.abb2cc2a.png";